var render = function render(){var _vm=this,_c=_vm._self._c;return _c('email-login-form',{attrs:{"bad-link":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }